// Theme configuration
export const theme = {
  colors: {
    // Base colors
    background: {
      primary: 'hsl(var(--background))',
      secondary: 'hsl(var(--secondary))',
      tertiary: 'hsl(var(--muted))'
    },
    border: 'hsl(var(--border))',
    text: {
      primary: 'hsl(var(--foreground))',
      secondary: 'hsl(var(--muted-foreground))'
    },
    accent: {
      primary: 'hsl(var(--primary))',
      secondary: 'hsl(var(--secondary))'
    }
  },
  radius: {
    sm: '0.375rem',    // 6px
    md: '0.5rem',      // 8px
    lg: '0.75rem',     // 12px
    xl: '1rem',        // 16px
    '2xl': '1.25rem',  // 20px
    full: '9999px'
  },
  spacing: {
    xs: '0.25rem',     // 4px
    sm: '0.5rem',      // 8px
    md: '1rem',        // 16px
    lg: '1.5rem',      // 24px
    xl: '2rem',        // 32px
    '2xl': '3rem'      // 48px
  },
  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)'
  },
  transitions: {
    default: 'all 0.2s ease-in-out',
    fast: 'all 0.1s ease-in-out',
    slow: 'all 0.3s ease-in-out'
  },
  typography: {
    fontFamily: {
      sans: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    },
    fontSize: {
      xs: '0.75rem',    // 12px
      sm: '0.875rem',   // 14px
      base: '1rem',     // 16px
      lg: '1.125rem',   // 18px
      xl: '1.25rem',    // 20px
      '2xl': '1.5rem',  // 24px
      '3xl': '1.875rem',// 30px
      '4xl': '2.25rem', // 36px
    },
    fontWeight: {
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
    },
  }
};

// Helper functions
export const getThemeColor = (path) => {
  const parts = path.split('.');
  let current = theme.colors;
  
  for (const part of parts) {
    if (!current[part]) {
      console.warn(`Color path "${path}" not found in theme`);
      return 'hsl(var(--foreground))'; // Fallback color
    }
    current = current[part];
  }
  
  return current;
};

export const getRadius = (size) => theme.radius[size] || theme.radius.md;
export const getSpacing = (size) => theme.spacing[size] || theme.spacing.md;
export const getShadow = (size) => theme.shadows[size] || theme.shadows.md;
export const getTransition = (speed) => theme.transitions[speed] || theme.transitions.default;

export const getFontSize = (size) => theme.typography.fontSize[size];
export const getFontWeight = (weight) => theme.typography.fontWeight[weight]; 